import { Menu, X } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function Navbar({ menuOpen, setMenuOpen, navItems }) {
  const { t } = useTranslation()

  return (
    <header className="fixed top-0 left-0 w-full bg-white dark:bg-gray-800 shadow z-50">
      <nav className="max-w-6xl mx-auto flex items-center justify-between p-4 relative text-gray-800 dark:text-gray-100">
        <div className="flex items-center space-x-2">
          <img
            src="/logo_dark.png"
            className="h-12 w-auto hidden dark:inline"
            alt="Logo Autodoprava Chochola"
          />
          <img
            src="/logo.png"
            className="h-12 w-auto dark:hidden"
            alt="Logo Autodoprava Chochola"
          />
        </div>
        <div className="lg:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu toggle"
          >
            {menuOpen ? (
              <X className="w-6 h-6 text-primary" />
            ) : (
              <Menu className="w-6 h-6 text-primary" />
            )}
          </button>
        </div>
        {menuOpen && (
          <>
            <div
              className="fixed top-24 inset-0 bg-white/20 dark:bg-dark/20 backdrop-blur-sm z-30"
              aria-hidden="true"
              onClick={() => setMenuOpen(false)}
            />
            <ul className="absolute top-full left-0 w-full bg-white dark:bg-gray-800 flex flex-col items-center justify-center space-y-4 py-6 shadow-lg z-40">
              {navItems.map((item) => (
                <li key={item.slug} onClick={() => setMenuOpen(false)}>
                  <a
                    href={`#${item.slug}`}
                    className="hover:text-primary transition px-4 block"
                  >
                    {item.label.charAt(0).toUpperCase() + item.label.slice(1)}
                  </a>
                </li>
              ))}
              <li className="py-4">
                <a
                  href="#kontakt"
                  onClick={() => setMenuOpen(false)}
                  className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary transition"
                >
                  {t("hero.cta")}
                </a>
              </li>
            </ul>
          </>
        )}
        <ul className="hidden lg:flex md:space-x-2 items-center">
          {navItems.map((item) => (
            <li key={item.slug} onClick={() => setMenuOpen(false)}>
              <a
                href={`#${item.slug}`}
                className="hover:text-primary transition px-4 block"
              >
                {item.label.charAt(0).toUpperCase() + item.label.slice(1)}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#kontakt"
              className="bg-primary text-white px-5 py-2 rounded-lg hover:bg-primary transition text-base"
            >
              {t("hero.cta")}
            </a>
          </li>
        </ul>
      </nav>
    </header>
  )
}
